import React from 'react';
import { Library } from 'lucide-react';
import { flattenTree, descendantIds } from './categoryUtils';

export const CategoryTreeSidebar = ({ categories, blocks, selected, onSelect }) => {
  const tree = flattenTree(categories);
  const rollup = (catId) => {
    const ids = descendantIds(categories, catId);
    return blocks.filter(b => (b.category_ids || []).some(c => ids.has(c))).length;
  };
  return (
    <nav className="w-56 shrink-0 hidden md:block" data-testid="rfp-category-sidebar">
      <button onClick={() => onSelect('')}
        className={`w-full flex items-center gap-2 text-xs rounded-md px-2.5 py-1.5 mb-1 transition-colors ${!selected ? 'bg-[#0F2040] text-white font-semibold' : 'text-slate-600 hover:bg-slate-100'}`}
        data-testid="rfp-sidebar-all">
        <Library className="w-3.5 h-3.5" />
        All Capabilities
        <span className={`ml-auto text-[10px] ${!selected ? 'text-white/70' : 'text-slate-400'}`}>{blocks.length}</span>
      </button>
      {tree.map(c => {
        const active = selected === c.id;
        const count = rollup(c.id);
        return (
          <button key={c.id} onClick={() => onSelect(active ? '' : c.id)}
            className={`w-full flex items-center gap-2 text-xs rounded-md px-2.5 py-1.5 transition-colors ${active ? 'bg-[#0F2040] text-white font-semibold' : 'text-slate-600 hover:bg-slate-100'}`}
            style={{ paddingLeft: `${10 + c.depth * 14}px` }}
            data-testid={`rfp-sidebar-cat-${c.id}`}>
            <span className="w-2 h-2 rounded-full shrink-0 border border-black/10"
              style={{ backgroundColor: c.color || '#CBD5E1' }} />
            <span className="truncate">{c.name}</span>
            <span className={`ml-auto text-[10px] ${active ? 'text-white/70' : 'text-slate-400'}`}>{count}</span>
          </button>
        );
      })}
    </nav>
  );
};
